<template>
  <div class="Orders">
    <div class="page-title">{{ title }}</div>
    <div class="flex">
      <div class="lt-area flex-auto">
        <el-input
          v-model="searchWord"
          class="input-with-select"
          size="mini"
          style="width: 300px;"
          :placeholder="placeholder"
          clearable
          @keydown.enter.native="handleClickFilter"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleClickFilter"
          />
        </el-input>

        <div class="right-search-head inline" style="margin-left: 10px">
          <div class="inline">
            <APeriodSelector
              ref="period"
              value="1w"
              @change="handleChangePeriod"
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
              >검색(F5)</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row-splitter">
      <ATable
        ref="table_contract"
        max-height="700px"
        v-loading="loading_contract"
        :data="filterDataContract"
        :cell-style="cellStyleOrder"
        hide-button-insert
        hide-pagination
        border
        @selection-change="contractSelectionChange"
      >
        <div slot="search" class="list-title">
          발주 리스트
        </div>
        <el-table-column
          type="selection"
          label="선택"
          align="center"
          :width="$width.selection"
        />
        <el-table-column
          type="index"
          label="No"
          :index="handleIndex"
          :width="$width.index"
        />
        <el-table-column prop="code" label="발주번호" width="100" />
        <el-table-column
          prop="order_inbound_state"
          label="입고 상태"
          width="100"
          :formatter="formatInboundState"
        />
        <el-table-column
          prop="customer_name"
          label="거래처"
          width="150"
          show-overflow-tooltip
        />
        <el-table-column
          prop="product_name"
          label="품목명"
          show-overflow-tooltip
        />
        <el-table-column
          prop="size"
          :label="$t('lang.size')"
          width="150"
          show-overflow-tooltip
        />
        <el-table-column prop="unit_name" label="단위" width="50" />
        <el-table-column
          prop="amount"
          label="발주량"
          class-name="cell-number"
          width="80"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="remain_amount"
          label="잔량"
          class-name="cell-number"
          width="80"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="price"
          label="금액"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="delay_flag"
          label="상태"
          :formatter="resolveStatusOrder"
          width="100"
        />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <div slot="buttons">
          <el-button
            type="primary"
            :disabled="
              processing || contractSelection.length < 1 || !has_grant_write
            "
            @click="handleClickSaveSale"
            >입고 등록</el-button
          >
        </div>
      </ATable>
    </div>
  </div>
</template>
<script>
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import { inbound_process } from "@/common/mixins/inbound_process";

export default {
  name: "Orders",
  mixins: [form_container, authority_level, inbound_process],
  data() {
    return {
      title: this.$t("title.orders"),
      period: {},
      placeholder: "발주번호, 거래처, 품목명",
      search_field: ["code", "order_code", "customer_name", "product_name"],
      searchWord: null,
      fixedSearchWord: "",
      loading_contract: false,
      items_contract: [],
      contractSelection: [],
      items_sale: [],
      form_data: undefined,
    };
  },
  computed: {
    /* 발주 */
    filterDataContract: function() {
      return this.util.filterMultiFields(
        this.items_contract,
        this.search_field,
        this.fixedSearchWord
      );
    },
    pay_way_flag_options: function() {
      return this.system.options.pay_way_flag;
    },
    has_grant_write() {
      return this.isWriteLevel("inbound");
    },
  },
  mounted() {
    this.$nextTick(() => this.handleClickSearch());
  },
  methods: {
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      // 입고 등록 중에는 목록을 다시 불러오지 않는다.
      if (this.processing) {
        return;
      }
      if (!this.period.valid) {
        return;
      }
      this.currentPageContract = 1;
      this.currentPageSale = 1;
      this.loadData();
    },
    handleClickFilter() {
      this.currentPageContract = 1;
      this.currentPageSale = 1;
      this.fixedSearchWord = this.searchWord;
    },
    loadInboundOrder() {
      this.loading_contract = true;
      this.api.listInboundOrder(this.period).then((res) => {
        this.loading_contract = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items_contract = res.data;
      });
    },
    loadData() {
      this.loadInboundOrder();
      this.loadInbound();
    },
    compareContract() {
      return function(a, b) {
        if (a.code < b.code) {
          return -1;
        } else if (a.code === b.code) {
          return a.seq - b.seq;
        } else {
          return 1;
        }
        // const value1 = a[property];
        // const value2 = b[property];
        // return value1 - value2;
      };
    },
    cellStyleOrder({ row, column /*, rowIndex, columnIndex*/ }) {
      if (column.property === "delay_flag") {
        if (row["valid_date"] < this.util.getDateString()) {
          return { color: "red" };
        }
      }

      return null;
    },

    contractSelectionChange(selection) {
      this.contractSelection = selection;
    },
    handleCurrentChangeContract(value) {
      this.currentPageContract = value;
    },
    handleCurrentChangeSale(value) {
      this.currentPageSale = value;
    },
    handleIndex(index) {
      return this.$refs.table_contract.indexResolver(index);
    },

    handleClickSaveSale() {
      if (this.contractSelection.length < 1) {
        this.util.notify_warning(
          this,
          this.title,
          this.$t("message.no_selection")
        );
        return;
      }
      if (this.processing) {
        return;
      }
      let params = this.contractSelection.map((item) => item.id);
      params.sort(function(a, b) {
        return a - b;
      });
      // 성공/실패와 관계없이 목록을 다시 불러와 선택을 초기화한다.
      this.registerInboundByChunk(params).then(() => this.handleClickSearch());
    },
    resolveStatusOrder(row) {
      return row["valid_date"] < this.util.getDateString() ? "지연" : "진행";
    },
  },
};
</script>
